namespace Nobox.Chat {
    export interface FunnelArr {
        Countfunn?: number;
        Nmfunn?: string;
        Clrfunn?: string;
        Id?: number;
    }
}
